<template>
  <div class="focus-layout page-wrap">
    <v-snackbar :timeout="4000" top right v-model="snackbar" class="notification">
      <div class="action">Message Sent</div>
      <v-btn text icon @click="snackbar = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
    <hidden point="mdUp">
      <div class="logo logo-header">
        <router-link :to="routeLink.saas.home">
          <img :src="logo" alt="B" />
          <span class="use-text-title">
            {{ brand.projectName }}
          </span>
        </router-link>
      </div>
    </hidden>
    <v-container class="inner-wrap max-md">
      <v-btn :href="routeLink.saas.home" icon class="backtohome">
        <v-icon v-text="'mdi-home-outline'" />
        <v-icon v-text="'mdi-arrow-left'" />
      </v-btn>
      <div class="decoration">
        <svg class="left-deco">
          <use :xlink:href="ASSETS_URL + 'images/saas/deco-bg-left.svg#main'" />
        </svg>
        <svg class="right-deco">
          <use :xlink:href="ASSETS_URL + 'images/saas/deco-bg-right.svg#main'" />
        </svg>
      </div>
      <v-card class="form-box div-fadeUp">
        <div class="full-form-wrap">
          <h3 class="use-text-title title-contact pb-3 text-center">
            <span v-t="'Say Hello to Us'" />
          </h3>
          <div class="form">
            <v-form ref="form" v-model="valid">
              <v-row class="spacing6">
                <v-col cols="12" sm="6" class="px-6">
                  <v-text-field
                    v-model="name"
                    :rules="nameRules"
                    :label="$t('What is your name? *')"
                    color="white"
                    class="input light"
                    filled
                    required
                  />
                </v-col>
                <v-col cols="12" sm="6" class="px-6">
                  <v-text-field
                    v-model="email"
                    :rules="emailRules"
                    :label="$t('What is your email? *')"
                    class="input light"
                    color="white"
                    filled
                    required
                  />
                </v-col>
                <v-col cols="12" sm="6" class="px-6">
                  <v-text-field
                    v-model="phone"
                    :label="$t('What is your phone number?')"
                    color="white"
                    class="input light"
                    filled
                  />
                </v-col>
                <v-col cols="12" sm="6" class="px-6">
                  <v-text-field
                    v-model="company"
                    :label="$t('What is your company?')"
                    color="white"
                    class="input light"
                    filled
                  />
                </v-col>
                <v-col cols="12" class="px-6">
                  <v-textarea
                    v-model="message"
                    rows="6"
                    color="white"
                    class="input light"
                    filled
                    :label="$t('Write your message here')"
                  />
                </v-col>
              </v-row>
              <div class="btn-area flex">
                <div class="form-control-label">
                  <v-checkbox
                    v-model="checkbox"
                    color="secondary"
                    :rules="[v => !!v || 'You must agree to continue!']"
                    :label="$t('I have read and accept the terms')"
                    class="white-label"
                    required
                  />
                  <span>
                    <a href="#" class="link">
                      <span v-t="'Read the terms'" />
                    </a>
                  </span>
                </div>
                <v-btn :block="isMobile" color="secondary" @click="validate" large>
                  <span v-t="'Send Message'" />
                </v-btn>
              </div>
            </v-form>
          </div>
        </div>
      </v-card>
    </v-container>
  </div>
</template>

<style lang="scss" scoped>
@import "@/landing/layout/FocusLayout/form-style.scss";
@import "@/_shared/scss/saas/_title-style.scss";
</style>

<script>
import logo from "@/landing/static/logo.svg";
import brand from "@/landing/static/text/brand";
import link from "@/landing/static/text/link";
// import Hidden from "../Hidden";

export default {
  //   components: {
  //     Hidden,
  //   },
  data() {
    return {
      valid: true,
      snackbar: false,
      name: "",
      nameRules: [v => !!v || "Name is required"],
      email: "",
      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      phone: "",
      company: "",
      message: "",
      checkbox: false,
      logo: logo,
      brand: brand,
      routeLink: link,
    };
  },
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
      }
    },
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
      //   const smDown = this.$store.state.breakpoints.smDown
      //   return smDown.indexOf(this.$mq) > -1
    },
  },
};
</script>
